require('./stylesheets/refill.scss');
angular.module('pages.receipt', [])
    .config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
    $stateProvider
        .state('pages.receipt', {
            url: 'receipt/:payment_id',
            template: require('./templates/index.html'),
            controller: require('./controllers/receipt.controller.js'),
            params: {
                payment_id: null,
                category_name: null,
                category_id: null,
                service_id: null,
                service_furl: null
            },
            data: {
                restricted: false,
                iframe: true
            },
            pageTrack: '/receipt'
        })
}

module.exports = 'pages.receipt';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/index.js
 ** module id = 285
 ** module chunks = 1
 **/